import { render, staticRenderFns } from "./detailComponents.vue?vue&type=template&id=c62621b4&"
import script from "./detailComponents.vue?vue&type=script&lang=js&"
export * from "./detailComponents.vue?vue&type=script&lang=js&"
import style0 from "./detailComponents.vue?vue&type=style&index=0&id=c62621b4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports